import type { BackendTrackingMetaData } from '@xing-com/crate-social-types';

type GetSocialTrackingMetaDataProps = (props: {
  backendTrackingMetaData?: BackendTrackingMetaData;
  propSocialInteractionId?: string;
  referrerUrl?: string;
}) => {
  trackingMetadata: {
    channel: 'web';
    deliveryTimestamp: string;
    page?: string;
    position?: string;
    referrerUrl: string;
    trackingTokens?: string[] | [];
    trackingUUID: string;
    userAgent: string;
  };
};

export const getSocialTrackingMetaData: GetSocialTrackingMetaDataProps = ({
  backendTrackingMetaData = { page: '', position: '', trackingTokens: [''] },
  propSocialInteractionId = '',
  referrerUrl,
}) => ({
  trackingMetadata: {
    channel: 'web',
    deliveryTimestamp: new Date(Date.now()).toISOString(),
    referrerUrl: referrerUrl || global?.top?.location?.href || '',
    trackingUUID: propSocialInteractionId,
    userAgent: global?.navigator?.userAgent || '',
    ...backendTrackingMetaData,
  },
});
